// BubbleCha i18n — All UI strings in zh / en / ja
// zh: Traditional Chinese (台灣繁體中文)
// en: English
// ja: Japanese (日本語)

export const COPY = {
  // ── App shell ────────────────────────────────────────────
  appName:          { zh: '泡泡茶 BubbleCha',     en: '泡泡茶 BubbleCha',      ja: '泡泡茶 BubbleCha' },
  tagline:          { zh: 'Premium Taiwanese Tea', en: 'Premium Taiwanese Tea', ja: 'プレミアム台湾茶' },

  // Lang buttons
  langZh:           { zh: '中文', en: '中文', ja: '中文' },
  langEn:           { zh: 'EN',   en: 'EN',   ja: 'EN'   },
  langJa:           { zh: '日本語', en: '日本語', ja: '日本語' },

  // Common actions
  back:             { zh: '返回',   en: 'Back',          ja: '戻る' },
  returnHome:       { zh: '返回首頁', en: 'Return to Home', ja: 'ホームに戻る' },
  viewAll:          { zh: '查看全部', en: 'View All',       ja: 'すべて見る' },
  helpText:         { zh: '如有疑問請聯繫門市服務人員', en: 'For questions, please contact store staff', ja: 'ご不明な点は店舗スタッフにお問い合わせください' },

  // ── Bottom Nav ────────────────────────────────────────────
  navHome:          { zh: '首頁',   en: 'Home',    ja: 'ホーム' },
  navMenu:          { zh: '菜單',   en: 'Menu',    ja: 'メニュー' },
  navRewards:       { zh: '獎勵',   en: 'Rewards', ja: '報酬' },
  navProfile:       { zh: '個人',   en: 'Profile', ja: 'プロフィール' },

  // ── HomeScreen (member_home) ──────────────────────────────
  memberSince:      { zh: '會員自 2024/03 起', en: 'Member since Mar 2024', ja: '2024年3月からのメンバー' },
  availablePoints:  { zh: '可用點數',     en: 'Available Points',      ja: '利用可能ポイント' },
  pointsUnit:       { zh: '點',           en: 'Pts',                   ja: 'ポイント' },
  myQualifications: { zh: '我的活動資格', en: 'My Event Qualifications', ja: '私のイベント資格' },
  eventNameHome:    { zh: '四月扭蛋祭 × 限定扭蛋', en: 'April Capsule Festival × Limited', ja: '4月ガチャ祭×限定' },
  validUntil:       { zh: '有效至 2026/04/25', en: 'Valid until Apr 25, 2026', ja: '2026/04/25まで有効' },
  statusAvailable:  { zh: '可使用', en: 'Available', ja: '使用可能' },
  useQualification: { zh: '使用活動資格',  en: 'Use Qualification',    ja: '資格を使用' },
  redeemWithPoints: { zh: '點數兌換扭蛋',  en: 'Redeem Gashapon with Points', ja: 'ポイントでガチャを交換' },
  recentRedemptions:{ zh: '最近兌換紀錄',  en: 'Recent Redemptions',   ja: '最近の交換履歴' },
  gachaRedemption:  { zh: '扭蛋兌換',     en: 'Gashapon Redemption',  ja: 'ガチャ交換' },
  eventBonus:       { zh: '活動贈點',     en: 'Event Bonus Points',   ja: 'イベントボーナスポイント' },
  luckyTea:         { zh: '今日幸運茶',   en: "Today's Lucky Tea",    ja: '今日のラッキーティー' },
  luckyTeaName:     { zh: '黑糖珍珠鮮奶', en: 'Brown Sugar Pearl Milk', ja: '黒糖パールミルク' },

  // ── EventDetailScreen ─────────────────────────────────────
  limitedEvent:     { zh: '限時活動',     en: 'Limited Event',        ja: '期間限定' },
  eventTitle:       { zh: 'April Capsule Festival', en: 'April Capsule Festival', ja: 'April Capsule Festival' },
  eventSubtitle:    { zh: '四月扭蛋祭',   en: 'April Capsule Festival', ja: '4月ガチャ祭' },
  eventPartner:     { zh: '泡泡茶 × 擎天聯名限定', en: 'BubbleCha × Joint Limited Edition', ja: '泡泡茶×コラボ限定' },
  eventPeriod:      { zh: '活動期間：2026/04/01 – 04/25', en: 'Period: Apr 1 – Apr 25, 2026', ja: '期間：2026/04/01 – 04/25' },
  eventRules:       { zh: '活動說明',     en: 'Event Details',        ja: '活動詳細' },
  rule1:            { zh: '消費滿 $150 即贈 1 次扭蛋兌換資格', en: 'Spend $150 to earn 1 gashapon chance', ja: '$150以上で1回のガチャ資格獲得' },
  rule2:            { zh: '每人每日最多獲得 2 次資格', en: 'Max 2 qualifications per person per day', ja: '1人1日最大2回まで' },
  rule3:            { zh: '或使用 50 點點數兌換 1 次', en: 'Or redeem 1 chance with 50 points', ja: '50ポイントで1回交換可能' },
  prizes:           { zh: '本次扭蛋內容', en: 'Prize Contents',        ja: '景品内容' },
  prize1:           { zh: '泡泡茶聯名公仔 (隱藏版 1/10)', en: 'BubbleCha Collab Figure (Hidden 1/10)', ja: '泡泡茶コラボフィギュア（隠れキャラ 1/10）' },
  prize2:           { zh: '隨機貼紙包 × 3', en: 'Random Sticker Pack × 3', ja: 'ランダムステッカーパック × 3' },
  prize3:           { zh: '飲品折扣券 $30', en: 'Drink Discount Coupon $30', ja: 'ドリンク割引クーポン$30' },
  prize4:           { zh: '點數加倍券 (下次消費 x2 點)', en: 'Points Doubler (Next purchase ×2 pts)', ja: 'ポイント2倍クーポン（次回購入）' },
  notes:            { zh: '注意事項',     en: 'Important Notes',      ja: '注意事項' },
  note1:            { zh: '活動資格限當日有效，過期自動失效', en: 'Qualifications valid same day only, auto-expire', ja: '当日のみ有効、期限切れは自動失効' },
  note2:            { zh: '每次兌換轉動一顆，不可累積', en: 'One spin per redemption, non-cumulative', ja: '1回につき1スピン、累積不可' },
  note3:            { zh: '活動最終解釋權歸泡泡茶所有', en: 'BubbleCha reserves all event interpretation rights', ja: '最終解釈権は泡泡茶に帰属' },
  statusLabel:      { zh: 'Status',       en: 'Status',               ja: 'ステータス' },
  myQualAvailable:  { zh: '我的活動資格：1 次可用', en: 'My Qualification: 1 Available', ja: '私の資格：1回使用可能' },
  currentPointsLabel:{ zh: '目前點數：1,250 點', en: 'Current Points: 1,250 Pts', ja: '現在のポイント：1,250ポイント' },
  useQualCta:       { zh: '立即使用資格', en: 'Use Qualification Now', ja: '今すぐ資格を使用' },
  redeemWithPtsCta: { zh: '用 50 點兌換', en: 'Redeem with 50 Points', ja: '50ポイントで交換' },

  // ── RedemptionConfirmScreen ───────────────────────────────
  confirmTitle:     { zh: '兌換確認',     en: 'Redemption Confirm',   ja: '交換確認' },
  pointsMode:       { zh: '點數兌換',     en: 'Points Redemption',    ja: 'ポイント交換' },
  tokenMode:        { zh: '活動 Token',   en: 'Event Token',          ja: 'イベントトークン' },
  gachaName:        { zh: '雙層扭蛋機 × 1 次', en: 'Double Gashapon × 1 Play', ja: 'ダブルガチャ × 1回' },
  deductPoints:     { zh: '扣除點數',     en: 'Points to Deduct',     ja: '差し引くポイント' },
  balanceAfter:     { zh: '兌換後餘額',   en: 'Balance After',        ja: '交換後残高' },
  warningTitle:     { zh: '請確認後再繼續', en: 'Please Confirm Before Continuing', ja: '続ける前にご確認ください' },
  warningDesc:      { zh: '點擊確認後將立即扣除點數並產生一次性條碼，無法撤銷。', en: 'Confirming will immediately deduct points and generate a one-time barcode. This cannot be undone.', ja: '確認後、すぐにポイントが差し引かれワンタイムバーコードが生成されます。取り消せません。' },
  barcodeNote:      { zh: '條碼產生後 5 分鐘內有效，請在機台前再點擊確認', en: 'Barcode valid 5 min after generation. Confirm at the machine.', ja: 'バーコードは生成後5分間有効。機台前で確認してください。' },
  confirmCta:       { zh: '確認，產生條碼', en: 'Confirm, Generate Barcode', ja: '確認してバーコードを生成' },
  cancel:           { zh: '取消',         en: 'Cancel',               ja: 'キャンセル' },

  // ── BarcodeDisplayScreen ──────────────────────────────────
  scanInstruction:  { zh: '請將此畫面對準機台掃描器', en: 'Align this screen with the machine scanner', ja: '画面を機械のスキャナーに向けてください' },
  userName:         { zh: '林珍珠',       en: 'Pearl Lin',            ja: 'リン・ジェンジュ' },
  redemptionType:   { zh: '點數兌換 · 50 點', en: 'Points Redemption · 50 Pts', ja: 'ポイント交換 · 50pt' },
  barcodeValidTime: { zh: '條碼有效時間', en: 'Barcode Valid For',     ja: 'バーコード有効時間' },
  brightnessNote:   { zh: '保持螢幕亮度最高以確保掃描成功', en: 'Maximize screen brightness for successful scan', ja: 'スキャン成功のため画面輝度を最大に' },
  scanSuccess:      { zh: '聽到「嗶」聲後請稍候出球', en: 'Wait for the "beep" then collect your prize', ja: '「ピー」音の後、景品をお受け取りください' },
  refreshBarcode:   { zh: '更新條碼',     en: 'Refresh Barcode',      ja: 'バーコードを更新' },
  barcodeExpiredMsg:{ zh: '條碼已過期',   en: 'Barcode Expired',      ja: 'バーコードの期限切れ' },
  regenerate:       { zh: '重新產生條碼', en: 'Regenerate Barcode',   ja: 'バーコードを再生成' },

  // ── SuccessCelebrationScreen ──────────────────────────────
  congrats:         { zh: '恭喜你！',     en: 'Congratulations!',     ja: 'おめでとう！' },
  capsuleReleased:  { zh: '扭蛋已釋放，請從取物口取出你的扭蛋', en: 'Capsule released! Collect from the dispenser.', ja: 'カプセルが出ました！取り出し口からお受け取りください' },
  collectReminder:  { zh: '請記得從機台下方取出你的扭蛋！', en: 'Remember to collect your capsule from the machine!', ja: '機台下部から扭蛋をお受け取りください！' },
  thisRedemption:   { zh: '本次兌換',     en: 'This Redemption',      ja: '今回の交換' },
  gachaItem:        { zh: '雙層扭蛋機 × 1 顆', en: 'Double Gashapon × 1 Ball', ja: 'ダブルガチャ × 1個' },
  pointsDeducted:   { zh: '扣除點數',     en: 'Points Deducted',      ja: '差し引いたポイント' },
  remainingPoints:  { zh: '剩餘點數',     en: 'Remaining Points',     ja: '残りポイント' },
  promoText:        { zh: '集點換好禮，下次消費再得 50 點！', en: 'Earn great rewards! Get 50 more points next purchase!', ja: 'ポイントを集めてプレゼントをゲット！次回購入で50ポイント追加！' },
  playAgain:        { zh: '再玩一次',     en: 'Play Again',           ja: 'もう一度プレイ' },
  shareExperience:  { zh: '分享這次體驗', en: 'Share This Experience', ja: 'この体験をシェア' },

  // ── ErrorScreen ───────────────────────────────────────────
  usedTab:          { zh: '已使用',       en: 'Used',                 ja: '使用済み' },
  expiredTab:       { zh: '已過期',       en: 'Expired',              ja: '期限切れ' },
  insufficientTab:  { zh: '點數不足',     en: 'Insufficient Points',  ja: 'ポイント不足' },
  barcodeExpiredTitle:{ zh: '條碼已過期', en: 'Barcode Expired',      ja: 'バーコードの有効期限切れ' },
  barcodeExpiredDesc:{ zh: '抱歉，條碼已超過 5 分鐘有效時間。請重新產生條碼以繼續進行兌換。', en: 'Sorry, the barcode has exceeded its 5-minute validity. Please regenerate to continue.', ja: '申し訳ありません。バーコードの5分有効期限を超えました。再生成して続けてください。' },
  insufficientTitle:{ zh: '點數不足',     en: 'Insufficient Points',  ja: 'ポイント不足' },
  insufficientDesc: { zh: '兌換此扭蛋需要 50 點，你目前只有 20 點。再消費即可累積更多點數！', en: 'This capsule requires 50 points, but you only have 20. Spend more to earn more!', ja: 'このガチャには50ポイントが必要ですが、現在20ポイントしかありません。' },
  currentPts:       { zh: '目前點數',     en: 'Current Points',       ja: '現在のポイント' },
  stillNeeded:      { zh: '尚缺',         en: 'Still Needed',         ja: 'あと' },
  requiredPoints:   { zh: '扭蛋需求',     en: 'Required',             ja: 'ガチャ要件' },
  completionRate:   { zh: '完成比例',     en: 'Completion',           ja: '達成率' },
  howToEarn:        { zh: '查看累點方式', en: 'How to Earn Points',   ja: 'ポイントの貯め方を見る' },
  quickEarnTip:     { zh: '快速集點攻略', en: 'Quick Point-Earning Tips', ja: '素早くポイントを貯めるヒント' },
  quickEarnDesc:    { zh: '購買大杯飲品可獲得雙倍點數', en: 'Buy large size drinks to earn double points', ja: 'Lサイズドリンク購入でポイント2倍' },
  quickHelp:        { zh: '快速協助',     en: 'Quick Help',           ja: 'クイックヘルプ' },
  faqSupport:       { zh: 'FAQ & 常見問題', en: 'FAQ & Support',     ja: 'FAQ＆サポート' },
  memberBenefits:   { zh: '會員權益',     en: 'Member Benefits',      ja: '会員特典' },
  doublePointsDay:  { zh: '雙倍點數日',   en: 'Double Points Day',    ja: 'ポイント2倍デー' },
  usedTitle:        { zh: '條碼已使用',   en: 'Barcode Already Used', ja: 'バーコード使用済み' },
  usedDesc:         { zh: '此條碼已完成兌換，無法再次使用。請重新開始兌換流程。', en: 'This barcode has already been redeemed and cannot be used again.', ja: 'このバーコードはすでに使用済みです。再利用できません。' },

  // ── MemberBarcodeScreen ───────────────────────────────────
  memberCard:       { zh: '會員卡',       en: 'Member Card',          ja: '会員カード' },
  scanToEarn:       { zh: '掃描結帳以累積點數', en: 'Scan at register to earn points', ja: 'レジでスキャンしてポイントを獲得' },
  currentBalance:   { zh: '目前餘額',     en: 'Current Balance',      ja: '現在の残高' },
  goldTier:         { zh: '黃金會員',     en: 'Gold Tier',            ja: 'ゴールドランク' },
  nextReward:       { zh: '下一個獎勵',   en: 'Next Reward',          ja: '次の報酬' },
  toGo:             { zh: '還差',         en: 'to go',                ja: 'あと' },
  availableCoupons: { zh: '可用優惠券',   en: 'Available Coupons',    ja: '利用可能クーポン' },
  topUpBalance:     { zh: '帳戶儲值',     en: 'Top Up Balance',       ja: 'チャージする' },
  transactionHistory:{ zh: '交易記錄',    en: 'Transaction History',  ja: '取引履歴' },
  scanToEarnRedeem: { zh: '掃描以累積和兌換', en: 'Scan to Earn & Redeem', ja: 'スキャンして獲得・交換' },

  // ── MenuScreen ────────────────────────────────────────────
  searchPlaceholder:{ zh: '搜尋你喜愛的茶飲...', en: 'Search your favorite tea...', ja: 'お気に入りのお茶を検索...' },
  weeklySpecial:    { zh: '本週特選',     en: 'Weekly Special',       ja: '今週のスペシャル' },
  mangoTitle:       { zh: '芒果爆炸！',   en: 'Mango Boom!',          ja: 'マンゴーブーム！' },
  mangoDesc:        { zh: '限時供應，嘗試爆發滋味', en: 'Limited time only. Try the burst.', ja: '期間限定。爆発的な味を体験。' },
  catMilkTea:       { zh: '奶茶',         en: 'Milk Tea',             ja: 'ミルクティー' },
  catFruitTea:      { zh: '果茶',         en: 'Fruit Tea',            ja: 'フルーツティー' },
  catCoffee:        { zh: '咖啡',         en: 'Coffee',               ja: 'コーヒー' },
  catMatcha:        { zh: '抹茶',         en: 'Matcha',               ja: '抹茶' },
  mostLoved:        { zh: '最受歡迎',     en: 'MOST LOVED',           ja: '最人気' },
  quickAdd:         { zh: '快速加入',     en: 'Quick Add',            ja: 'すぐ追加' },

  // ── ProfileScreen ─────────────────────────────────────────
  profileName:      { zh: '陳美琳',       en: 'Mei Lin Chen',         ja: 'チェン・メイリン' },
  goldMember:       { zh: '黃金會員',     en: 'Gold Member',          ja: 'ゴールドメンバー' },
  bubblePoints:     { zh: 'Bubble 點數',  en: 'Bubble Points',        ja: 'バブルポイント' },
  editProfile:      { zh: '編輯個人資料', en: 'Edit Profile',         ja: 'プロフィール編集' },
  statCoupons:      { zh: '優惠券',       en: 'Coupons',              ja: 'クーポン' },
  statFreeDrinks:   { zh: '免費飲品',     en: 'Free Drinks',          ja: '無料ドリンク' },
  statBadgeLevel:   { zh: '徽章等級',     en: 'Badge Level',          ja: 'バッジレベル' },
  statFavorites:    { zh: '收藏',         en: 'Favorites',            ja: 'お気に入り' },
  accountSettings:  { zh: '帳號設定',     en: 'Account Settings',     ja: 'アカウント設定' },
  orderHistory:     { zh: '訂單記錄',     en: 'Order History',        ja: '注文履歴' },
  orderHistoryDesc: { zh: '查看你的飲茶冒險紀錄', en: 'View your previous tea adventures', ja: '過去のティーアドベンチャーを表示' },
  myCoupons:        { zh: '我的優惠券',   en: 'My Coupons',           ja: 'マイクーポン' },
  myCouponsDesc:    { zh: '兌換你的獨家獎勵', en: 'Redeem your exclusive rewards', ja: '限定報酬を交換' },
  paymentMethods:   { zh: '付款方式',     en: 'Payment Methods',      ja: 'お支払い方法' },
  paymentMethodsDesc:{ zh: '管理你的卡片和錢包', en: 'Manage your cards and wallet', ja: 'カードとウォレットを管理' },
  notifSettings:    { zh: '通知設定',     en: 'Notification Settings', ja: '通知設定' },
  notifSettingsDesc:{ zh: '飲品提醒和促銷更新', en: 'Tea alerts and promo updates', ja: 'ティーアラートとプロモーション更新' },
  logOut:           { zh: '登出',         en: 'Log Out',              ja: 'ログアウト' },
  version:          { zh: 'BubbleCha v0.1.0 • 為茶愛好者打造', en: 'BubbleCha v0.1.0 • Built for tea lovers', ja: 'BubbleCha v0.1.0 • ティー愛好家のために' },
};

// Helper hook usage: const t = useT(); t('appName')
export function useT(lang) {
  return (key) => {
    const entry = COPY[key];
    if (!entry) return key;
    return entry[lang] || entry['zh'] || key;
  };
}
